import React from 'react';
import { Button } from './ui/Button';
interface FinalCTAProps {
  onBookConsultation?: () => void;
}
export function FinalCTA({
  onBookConsultation
}: FinalCTAProps) {
  return <section className="py-32 md:py-40 bg-[#F2EFE9] relative overflow-hidden" data-id="element-89">
      {/* Subtle texture overlay could go here, using a gradient for now */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background/30 pointer-events-none" data-id="element-90"></div>

      <div className="container mx-auto px-4 md:px-8 relative z-10 text-center max-w-3xl" data-id="element-91">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-foreground leading-tight mb-6" data-id="element-92">
          Your skin already knows how to be beautiful.
        </h2>

        <p className="text-lg md:text-xl text-foreground/70 font-sans mb-12" data-id="element-93">
          Book a free consultation and let's show you what's possible.
        </p>

        <div className="flex flex-col items-center space-y-6" data-id="element-94">
          <Button size="lg" className="w-full md:w-auto md:px-16" onClick={onBookConsultation} data-id="element-95">
            Book My Free Consultation
          </Button>

          <p className="text-sage font-sans text-sm tracking-wide" data-id="element-96">
            No commitment. No pressure. Just a conversation.
          </p>
        </div>
      </div>
    </section>;
}